"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var DrawerBody_1 = __importDefault(require("./DrawerBody"));
var DrawerFooter_1 = __importDefault(require("./DrawerFooter"));
var DrawerHeader_1 = __importDefault(require("./DrawerHeader"));
var containerStyles = {
    default: react_1.css({
        position: 'absolute',
        top: 0,
        bottom: 0,
        background: '#fff',
        transition: 'all 0.3s ease',
        pointerEvents: 'initial',
        boxShadow: "var(" + variables_1.Shadow.xl + ")",
        overflow: 'hidden',
    }),
    size: {
        sm: react_1.css({
            width: "var(" + variables_1.ComponentLayout.DRAWER_WIDTH_SM + ")",
        }),
        md: react_1.css({
            width: "var(" + variables_1.ComponentLayout.DRAWER_WIDTH_MD + ")",
        }),
        lg: react_1.css({
            width: "var(" + variables_1.ComponentLayout.DRAWER_WIDTH_LG + ")",
        }),
        xl: react_1.css({
            width: "var(" + variables_1.ComponentLayout.DRAWER_WIDTH_XL + ")",
        }),
    },
    position: {
        left: react_1.css({
            transform: 'translateX(-100%)',
            left: 0,
            borderRight: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_3,
        }),
        right: {
            transform: 'translateX(100%)',
            right: 0,
            borderLeft: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_3,
        },
    },
};
var Drawer = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.position, position = _c === void 0 ? 'right' : _c, pageLevel = _a.pageLevel, open = _a.open, children = _a.children, _d = _a.backdrop, backdrop = _d === void 0 ? 'none' : _d, onRequestClose = _a.onRequestClose, _e = _a.closeOnBackdropClick, closeOnBackdropClick = _e === void 0 ? backdrop === 'none' ? false : true : _e;
    var handleOutsideClick = function () {
        if (closeOnBackdropClick) {
            onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
        }
    };
    return (react_1.jsx("div", { css: {
            position: pageLevel ? 'fixed' : 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            visibility: open ? 'visible' : 'hidden',
            zIndex: 50,
            overflow: 'hidden',
            pointerEvents: open && closeOnBackdropClick ? 'auto' : 'none',
            backgroundColor: open && backdrop === 'dark' ? 'rgba(0, 0, 0, .6)' : '',
        }, onClick: handleOutsideClick },
        react_1.jsx(layout_1.Flex, { direction: "column", css: [
                containerStyles.default,
                containerStyles.size[size],
                containerStyles.position[position],
                open
                    ? {
                        transform: 'translateX(0)',
                    }
                    : {
                        boxShadow: 'none',
                    },
            ], onClick: function (e) { return e.stopPropagation(); } }, children)));
};
exports.default = Object.assign(Drawer, {
    Header: DrawerHeader_1.default,
    Body: DrawerBody_1.default,
    Footer: DrawerFooter_1.default,
});
